import { useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Alert, Button, Card, Form, Result } from "antd";
import styles from "../Auth/Auth.module.css";
import NewPasswordFields from "../../fragments/NewPasswordFields";
import { acceptPasswordReset } from "../../utils";
import { tokenFromHash } from "../../utils/links";
import { useSession } from "../../session/SessionContext";

const ResetPassword: React.FC = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { signOut } = useSession();
  const token = tokenFromHash(location.hash);
  const [error, setError] = useState<string | null>(null);
  const [submitting, setSubmitting] = useState(false);
  const [done, setDone] = useState(false);

  const handleSubmit = async ({ password }: { password: string }) => {
    setSubmitting(true);
    setError(null);
    try {
      await acceptPasswordReset(token, password);
      signOut();
      setDone(true);
    } catch (e) {
      setError((e as Error).message);
      setSubmitting(false);
    }
  };

  if (done) {
    return (
      <Result
        status="success"
        title="Your password has been changed"
        extra={
          <Button type="primary" onClick={() => navigate("/login", { replace: true })}>
            Sign in
          </Button>
        }
      />
    );
  }

  return (
    <div className={styles.authWrapper}>
      <div className={styles.authCard}>
        <div className={styles.authLogo}>Brixture</div>
        <Card title="Choose a new password">
          <Form layout="vertical" onFinish={handleSubmit}>
            <NewPasswordFields />
            {error && <Alert type="error" title={error} style={{ marginBottom: 16 }} />}
            <Button type="primary" htmlType="submit" loading={submitting}>
              Set password
            </Button>
          </Form>
        </Card>
      </div>
    </div>
  );
};

export default ResetPassword;
